import React, { Fragment, useEffect, useState } from "react";
import { Popover, Transition } from "@headlessui/react";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import ClearDataButton from "./ClearDataButton";
import ButtonSubmit from "./ButtonSubmit";

const GuestsInput = ({
  defaultValue,
  value,
  onChange,
  fieldClassName = "[ nc-hero-field-padding ]",
  className = "[ nc-flex-1 ]",
  buttonSubmitHref = "/home",
  hasButtonSubmit = true,
  slots,
}) => {
  const handleChangeData = (value, close) => {
    onChange && onChange(value);
    close();
  };

  return (
    <Popover className={`flex relative ${className}`}>
      {({ open, close }) => (
        <>
          <div
            className={`flex-1 flex items-center focus:outline-none cursor-pointer ${
              open ? "nc-hero-field-focused" : ""
            }`}
          >
            <Popover.Button
              className={`flex-1 flex text-left items-center ${fieldClassName} space-x-3 `}
              onClick={() => document.querySelector("html")?.click()}
            >
              <div className="flex-grow">
                <span className="block xl:text-lg font-semibold">
                  {value?.name}
                </span>
                <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
                  Add slot
                </span>
              </div>
            </Popover.Button>

            {/* <div className="relative">
              {!!totalGuests && open && (
                <ClearDataButton
                  onClick={() => {
                    setGuestAdultsInputValue(0);
                    setGuestChildrenInputValue(0);
                    setGuestInfantsInputValue(0);
                  }}
                />
              )}
            </div> */}
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute right-0 z-10 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl">
              {slots?.map((slot, i) => (
                <NcInputNumber
                  className="w-full h-10"
                  defaultValue={i}
                  onClick={(value) => handleChangeData(i, close)}
                  max={10}
                  min={1}
                  isBlocked={slot?.isBlocked == true}
                  // desc="Ages 13 or above"
                  label={slot?.name}
                />
              ))}
              {/* // <NcInputNumber
              //   className="w-full mt-6"
              //   defaultValue={1}
              //   onClick={(value) => handleChangeData(1, close)}
              //   max={4}
              //   // desc="Ages 2–12"
              //   label="07pm - 12am"
              // /> */}
              {/* 
              <NcInputNumber
                className="w-full mt-6"
                defaultValue={guestInfantsInputValue}
                onChange={(value) => handleChangeData(value, "guestInfants")}
                max={4}
                label="Infants"
                desc="Ages 0–2"
              /> */}
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default GuestsInput;
